// Mirrors bioplanner.shared/Constants/ShiftExchangeStatus.cs. Only `open` rows are on the
// exchange; the rest are kept so a shared byttevagt link still resolves after the shift is gone.
export class BPShiftExchangeStatus {
}
BPShiftExchangeStatus.open = 0;
BPShiftExchangeStatus.acquired = 1;
BPShiftExchangeStatus.cancelled = 2;
BPShiftExchangeStatus.swapped = 3;
